import * as React from "react";
import { Objects } from "../Utils/Objects";
import { Assert } from "../Utils/Assert";
import { IStore } from "../Flux/BaseStore";
import { isNullOrEmpty } from "../Utils/Arrays";

export abstract class BaseComponent<TProps, TState> extends React.Component<TProps, TState> {
    private _subscribedStores: { store: IStore; onChange: () => void }[];

    private _storeSubscriptionsClosed: boolean;

    constructor(props: TProps) {
        super(props);
        this._subscribedStores = [];
        this._storeSubscriptionsClosed = false;
    }

    public UNSAFE_componentWillMount(): void {
        this._storeSubscriptionsClosed = true;
        this.subscribeToAllStores();
    }

    public componentWillUnmount(): void {
        this.cancelAllStoresSubscriptions();
    }

    protected isAnyStoreLoading(): boolean {
        if (!isNullOrEmpty(this._subscribedStores)) {
            for (let i = 0; i < this._subscribedStores.length; i++) {
                if (this._subscribedStores[i].store.isLoading()) {
                    return true;
                }
            }
        }

        return false;
    }

    protected updateStatePart(updateStatePartFunc: (state: TState) => void, callback?: () => any): void {
        this.setState((prevState: TState) => {
            const copiedState = Objects.cloneObject(prevState);
            updateStatePartFunc(copiedState);

            return copiedState;
        }, callback);
    }

    protected subscribeToStore(store: IStore, onChange: () => void): void {
        Assert(
            !this._storeSubscriptionsClosed,
            "Attempted to subscribe to a store after component is initialized. " +
                "subscribeToStore can be called only in a constructor"
        );
        this._subscribedStores.push({ store, onChange });
    }

    private subscribeToAllStores(): any {
        if (!isNullOrEmpty(this._subscribedStores)) {
            for (let i = 0; i < this._subscribedStores.length; i++) {
                this._subscribedStores[i].store.onChange(this, this._subscribedStores[i].onChange);
            }
        }
    }

    private cancelAllStoresSubscriptions(): any {
        if (!isNullOrEmpty(this._subscribedStores)) {
            for (let i = 0; i < this._subscribedStores.length; i++) {
                this._subscribedStores[i].store.removeChangeListener(this);
            }
        }
    }
}
